/**
 * AxGraph Providers
 */
function AxGraphProviders() {
  return {
    columnChart: function ($container, data) {
      var self = this;
      var ticks = [1, 2, 5, 10, 20, 50, 100, 200, 500, 900];

      var _createPane = function () {
        var $legend = $('<div class="legend"></div>');

        $.each(data.legend, function (key, value) {
          $legend.append('<div class="' + key + '"><span></span>' + value + '</div>');
        });

        if (data.values.length) {
          // Find Max value
          var max = Math.max.apply(null, data.values.map(function (item) {
            return (item) ? item.value : 0;
          }));
          // Detect upper bound
          for (var i = 0; i < ticks.length; i++) {
            if (max < ticks[i]) {
              self.bound = ticks[i];
              break;
            }
          }
        }
        ;
        // Create side labels/marks
        var $marks = $('<ul class="marks"></ul>');
        $marks.append('<li>' + self.bound + ' Gb</li>');
        $marks.append('<li>' + (self.bound / 2) + ' Gb</li>');
        $marks.append('<li>0 Gb</li>');
        // Create main layer
        self.$layer = $('<div class="bottom-layer"></div>');
        // Combine pane
        $container.append($legend);
        $container.append($marks);
        $container.append(self.$layer);
      };

      var _addColumn = function (i) {
        setTimeout(function () {
          var len = data.values.length;
          var value = (data.values[i] || {}).value || 0;
          var m = ((new Date()).getMonth() + i + 1) % 12;
          var $item = $('<div class="item" data-axtooltip="' + months_names[m] + ' - ' + value + ' GB"></div>');

          $item.css({
            height: Math.floor(value / self.bound * 100) + '%',
            width: (self.$layer.width() - len * 10) / len + 'px',
            left: (100 / len) * i + '%'
          });

          self.$layer.append($item);

          if (value > 0) {
            $item.hide();
            $item.slideDown(200);
          }

          i++;
          if (i < len) { _addColumn(i); }
        }, 60);
      };

      return {
        /**
         * Basic function
         */
        draw: function (data) {
          var i = 0; // column counter
          _createPane();
          _addColumn(i);
        }
      }
    },

    retentionGraph: function($container, data) {
      var self = this;

      var presets = {
        1: {
          lines: {
            x: [
              [44.5,  20.5,  539, 20.5],
              [77.5,  54.5,  539, 54.5],
              [119.5, 78.5,  539, 78.5],
              [200.5, 96.5,  539, 96.5],
              [359.5, 110.5, 539, 110.5],
              [525.5, 123.5, 539, 123.5],
            ],
            y: [
              [44.5,  10, 44.5,  20],     // oo
              [77.5,  10, 77.5,  54],     // 1d
              [119.5, 10, 119.5, 78],     // 3d
              [200.5, 10, 200.5, 96.5],   // 1m
              [359.5, 10, 359.5, 110],    // 3m
              [524.5, 10, 524.5, 123],    // 6m
            ]
          },
          columns: [
            [28.5, 20.5,  16,    114, '#3e8fa9'],   // immediately
            [45,   54.5,  32.5,  80,  '#4099b5'],   // hourly
            [78,   78.5,  41.5,  56,  '#43a0bd'],   // daily
            [120,  96.5,  80.5,  38,  '#46a7c5'],   // weekly (cloud)
            [201,  110.5, 158.5, 24,  '#8ac7ec'],   // monthly
            [360,  123.5, 165.5, 11,  '#92d0ef'],   // yearly
          ],
          width: [16, 28, 34, 40, 53, 320],
          legend: [
            [28.5,  135, 172, 15.5, '#3787a0'],     // local + cloud (1m)
            [201, 135, 324.5, 15.5, '#7dbddf'],     // cloud (3m)
          ]
        },
        3: {
          lines: {
            x: [
              [44.5, 20.5, 539, 20.5],
              [77.5, 54.5, 539, 54.5],
              [119.5, 78.5, 539, 78.5],
              [200.5, 96.5, 539, 96.5],
              [359.5, 110.5, 539, 110.5],
              [525.5, 123.5, 539, 123.5],
            ],
            y: [
              [44.5, 10, 44.5, 20],       // oo
              [77.5, 10, 77.5, 54],       // 1d
              [119.5, 10, 119.5, 78],     // 3d
              [200.5, 10, 200.5, 96.5],   // 1m
              [359.5, 10, 359.5, 110],    // 3m
              [524.5, 10, 524.5, 123],    // 6m
            ]
          },
          columns: [
            [28.5, 20.5, 16, 114, '#3e8fa9'],     // immediately
            [45, 54.5, 32.5, 80, '#4099b5'],      // hourly
            [78, 78.5, 41.5, 56, '#43a0bd'],      // daily
            [120, 96.5, 80.5, 38, '#46a7c5'],     // weekly (cloud)
            [201, 110.5, 158.5, 24, '#46adce'],   // monthly
            [360, 123.5, 165.5, 11, '#92d0ef'],   // yearly
          ],
          width: [16, 28, 34, 40, 53, 320],
          legend: [
            [28.5, 135, 331, 15.5, '#3787a0'],    // local + cloud (1m)
            [360, 135, 165.5, 15.5, '#7dbddf'],   // cloud (3m)
          ]
        }
      };

      var sections = [rt_graph_1_day, rt_graph_3_days, rt_graph_1_month, rt_graph_3_months, rt_graph_6_months];
      var labels = ['&#8734;', rt_graph_hourly, rt_graph_daily, rt_graph_weekly, rt_graph_monthly, rt_graph_yearly];

      var curve = [{x: 45, y: 21.5}, {x: 75.5, y: 56.5}, {x: 117.5, y: 80.5}, {x: 198.5, y: 98.5}, {x: 359.5, y: 110.5}, {x: 525.5, y: 123}];

      var stage = {};

      var _getCanvas = function() {
        var $canvas = $container.find('canvas#rt-gen3-graph');

        if (!$canvas.length) {
          $canvas = $('<canvas id="rt-gen3-graph" width="'+ $container.outerWidth() +'" height="'+ $container.outerHeight() +'"></canvas>');
          $container.wrapper = $('<div class="canvas-wrapper" width="'+ $container.outerWidth() +'" height="'+ $container.outerHeight() +'" style="position: absolute;" />');
          $container.wrapper.append($canvas);
          $container.append($container.wrapper);
        }

        return $canvas[0];
      };

      var _drawGrid = function(ctx) {
        ctx.lineWidth = 1;
        ctx.strokeStyle = 'rgba(230, 231, 231, 0.5)';

        for (var i = 0; i < stage.lines.x.length; i++) {
          _drawLine(ctx, stage.lines.x[i]);
          _drawLine(ctx, stage.lines.y[i]);
        }
      };

      var _drawLine = function(ctx, line) {
        ctx.beginPath();
        ctx.moveTo(line[0], line[1]);
        ctx.lineTo(line[2], line[3]);
        ctx.stroke();
      };

      var _drawColumns = function(ctx) {
				var background = '';
				var retVal = 0;
        for (var i = 0; i < stage.columns.length; i++) {
					background = stage.columns[i][4];
					retVal = $('#gen3_cloud_retention_length').val();
					if(i > 3 && retVal < 20) {
						background = '#ddd';
					}
					if(i > 4 && retVal < 35) {
						background = '#ddd';
					}
					if(i > 4 && retVal <= 95) {
						background = '#ddd';
					}
          ctx.fillStyle = background;
          ctx.fillRect(stage.columns[i][0], stage.columns[i][1], stage.columns[i][2], stage.columns[i][3]);
        }
      };

      var _drawCurve = function(ctx) {
        ctx.lineWidth = 1.6;
        ctx.strokeStyle = '#0d9b52';
        ctx.shadowBlur = 0.7;
        ctx.shadowColor = '#0d9b52';

        ctx.beginPath();
        ctx.moveTo(stage.curve[0].x, stage.curve[0].y);
        for (var i = 1; i < stage.curve.length - 2; i++) {
          var xc = (stage.curve[i].x + stage.curve[i+1].x) / 2;
          var yc = (stage.curve[i].y + stage.curve[i+1].y) / 2;
          ctx.quadraticCurveTo(stage.curve[i].x, stage.curve[i].y, xc, yc);
        }
        ctx.quadraticCurveTo(stage.curve[i].x, stage.curve[i].y, stage.curve[i+1].x, stage.curve[i+1].y);
        ctx.stroke();

        ctx.shadowBlur = 0;
      };

      var _drawLabels = function (ctx) {
        ctx.lineWidth = 1;
        ctx.strokeStyle = 'rgba(206, 207, 209, 1)';

        // X axis
        _drawLine(ctx, [66.5, 161.5, 524, 161.5]);
        _drawLine(ctx, [520, 157.5, 523.5, 161.5]);
        _drawLine(ctx, [520, 165.5, 523.5, 161.5]);
        // Y axis
        _drawLine(ctx, [18.5, 24.5, 18.5, 45.5]);
        _drawLine(ctx, [18.5, 24, 14.5, 28]);
        _drawLine(ctx, [18.5, 24, 22.5, 28]);

        /* Sections */
        for (var i = 0; i < stage.sections.length; i++) {
          var _top = stage.lines.y[i][1] - 10;
          var _left = stage.lines.y[i][0] + 3;
          $container.wrapper.append($('<div class="graph-section label el-'+ i +'" style="top: ' + _top + 'px; left: ' + _left + 'px">' + stage.sections[i] + '</div>'));
        }

        /* Labels */
        for (var i = 0; i < labels.length; i++) {
          var _top = stage.columns[i][1] + stage.columns[i][3] - 14.5;
          var _left = stage.columns[i][0] - 2;
          var _width = stage.columns[i][2];
          $container.wrapper.append($('<div class="graph-legend label el-'+ i +'" style="top: ' + _top + 'px; left: ' + _left + 'px; width: ' + _width + 'px">' + labels[i] + '</div>'));
        }

        /* Legend */
        for (var i = 0; i < stage.legend.length; i++) {
          ctx.fillStyle = stage.legend[i][4];
          ctx.fillRect(stage.legend[i][0], stage.legend[i][1], stage.legend[i][2], stage.legend[i][3]);
        }

        /* Axis X label */
        $container.wrapper.append($('<div class="axis-x label" style="top: ' + (stage.legend[0][1] + 16) + 'px; '
          + 'left: ' + stage.legend[0][0] + 'px;">' + rt_graph_over_time + '</div>'));
        /* Axis Y label */
        $container.wrapper.append($('<div class="axis-y label" style="top: ' + 86 + 'px; '
          + 'left: -30px;">' + rt_graph_recovey_points_remained + '</div>'));
      };

      var _createStage = function() {
        var years = Math.floor(self.options.cloud / 365);

        stage = presets[3];
        stage.curve = curve;
        stage.sections = sections;

        var last_section = (years > 1) ? Math.ceil(years) + ' ' + rt_graph_years : rt_graph_1_year;
        stage.sections.push(last_section);

        if (years > 1) {
          var dx = 0,     // column X axis offset
              total = 0,  // total available width
              width = 0;  // used width

          for (var i = 0; i < stage.columns.length; i++) {
            var dw = 0; // column width delta

            if (i > 0) {
              dw = (stage.columns[i][2] - stage.width[i]) / 10 * years;
              dw = (years < 1.5) ? 0 : Math.floor(dw);

              total += stage.columns[i][2];        // calculate total available width
              width += stage.columns[i][2] - dw;   // calculate current width used
            }

            // update lines coordinates (X axis): y[i] - vertical line, x[i] - horizontal line
            stage.lines.y[i][0] = stage.lines.y[i][2] = stage.lines.x[i][0] -= dx + dw;

            if (i == stage.columns.length - 1) {
              dw += width - total;        // fix +/- couple pixels gap for last column
            }

            // update column coordinates and width
            stage.columns[i][0] -= dx;    // move column left by "dx" pixels
            stage.columns[i][2] -= dw;    // make column thinner by "dw" pixels

            // update curve coordinates
            stage.curve[i].x = stage.columns[i][0] + stage.columns[i][2];
            if (i == stage.columns.length - 1) {
              stage.curve.push({x: stage.curve[i].x, y: stage.curve[i].y});
              // (1 + years / 12) - gives acceptable smooth
              stage.curve[i].x = stage.columns[i][0] + stage.columns[i-1][2] * (1 + years / 12);
            }

            // update legend coordinates and width
            if (stage.legend[1][0] > stage.columns[i][0]) {
              stage.legend[0][2] -= dw;   // make first legend item thinner by "dw" pixels
              stage.legend[1][2] += dw;   // make second legend item wider by "dw" pixels
              stage.legend[1][0] -= dw;   // move second legend item left by "dw" pixels
            }

            dx += dw; // X offset
          }
        }
      }

      var _drawStage = function() {
        var canvas = _getCanvas();
        var ctx = canvas.getContext('2d');

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        $container.wrapper.find('.label').remove();

        _drawGrid(ctx);
        _drawColumns(ctx);
        _drawCurve(ctx);
        _drawLabels(ctx);
      };

      return {
        /** Basic function */
        draw: function (options) {
          self.options = options;

          if (/*!presets[self.options.local] || */self.options.cloud > 3660) {
            console.log('retentionGraph: Incorrect data passed');
            return;
          }

          _createStage();
          _drawStage();
        }
      }
    }
  }
}

/**
 * AxGraph widget
 */
(function($) {
  $.widget('ui.axGraph', {
    options: {
      type: 'columnChart',
      data: {},
      request: {}
    },
    /**
     * Constructor
     * @private
     */
    _create: function() {
      var self = this;

      self.$container = self.element.find('.ax-graph');
    },
    /**
     * Initialize widget options
     * @private
     */
    _init: function(args) {
      var self = this;

      if (typeof args != "undefined") {
        for (var item in self.options) {
          if (typeof args[item] != "undefined") {
            self.options[item] = args[item];
          }
        }
      }
      // Show loader
      self.$container.hide();
      self.$loader = $('<div class="loading"></div>');
      self.$loader.insertAfter(self.$container);
      if (self.options.request.location) {
        self._getData();
      } else {
        self.draw(self.options.data);
      }
    },
    /**
     * Load data from server
     * @private
     */
    _getData: function () {
      var self = this;

      $.ajax({
        url: self.options.request.location,
        type: 'GET',
        dataType: 'json'
      }).done(function (data) {
        self.draw(data);
      });
    },

    /**
     * Adds description to the graph
     * @param description - language provided from controller.
     * @private
     */
    _createDescription: function(description){
      var self = this;
      if(description){
        self.element.find('.backup-history-desc').append(description);
      }
    },
    /**
     * Draws graph
     */
    draw: function(data) {
      var self = this;
      var type = self.options.type;
      var providers = new AxGraphProviders();

      self.$loader.hide();
      self.$container.fadeIn('slow');
      self.provider = providers[type](self.$container, data);
      self.provider.draw(data);

      if(self.options.showDescription === true){
        self._createDescription(data.description);
      }

    }
  });

  $.extend($.ui.axGraph, {
    version: "1.0.0"
  });
})(jQuery);
